module.exports = __webpack_public_path__ + "media/images/steps/png/031-businessman-47-51b7dcf4adec40ad39f4577148314483.png";